@if (showGraphs() && roadmapBuildingDetails() && isTranslationLoaded()) {
<div class="row">
  <div class="col-6 col-print-6 mt-5 h-100">
    <cfp-roadmap-chart
      (showDataEvent)="onShowData($event)"
      class="printable-roadmap-chart"
      [details]="roadmapBuildingDetails()"
      [responsive]="false"
      [propertyNames]="['investment', 'costReduction']"
      [title]="'investmentAndCostReduction'"
      [currencyCode]="roadmapBuildingDetails().currencyCode"
    />
  </div>
  <div class="col-6 col-print-6 mt-5 h-100">
    <cfp-roadmap-chart
      class="printable-roadmap-chart"
      (showDataEvent)="onShowData($event)"
      [details]="roadmapBuildingDetails()"
      [propertyNames]="['co2Consumption']"
    />
  </div>
</div>
<div class="row">
  <div class="col-6 col-print-6 mt-5 h-100">
    <cfp-roadmap-chart-usage
      (showDataEvent)="onShowData($event)"
      [details]="roadmapBuildingDetails()"
      [building]="building()"
    />
  </div>
  <div class="col-6 col-print-6 mt-5 h-100">
    <cfp-roadmap-chart
      (showDataEvent)="onShowData($event)"
      class="printable-roadmap-chart"
      [details]="roadmapBuildingDetails()"
      [propertyNames]="['co2ConsumptionReduction']"
    />
  </div>
</div>
}
